<template>
  <div class="text-center div_btn_inline">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            icon
            v-bind="attrs"
            v-on="on"
            @click="dialog = true"
          >
            <v-icon>
             public
            </v-icon>
          </v-btn>
      </template>
        <span>Participantes de la Encuesta</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay 
      transition="dialog-bottom-transition">
      <v-card>
         <v-toolbar dark color="primary" name="toolbar_dialog_form_participante">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-icon color="white">mdi-pencil</v-icon>
         Participantes en la Encuesta
                   </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">Cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        

         <div class="flex-grow-1">
          <div v-if="valido && !loadingEncuesta && error == ''" style="position: relative;">  
         <form-encuesta-participante :obj-encuesta="objEncuesta"  :flag-reload="flagReloadTable2"  :fn-on-save="obtenerGruposParticipanteEncuesta" ></form-encuesta-participante>
          <form-participantes-encuestas :obj-encuesta="objEncuesta"  :obj-participantes-encuesta="objParticipantesEncuesta"  :flag-reload="flagReloadTable"  ></form-participantes-encuestas>
          <data-table-invitaciones-encuesta :obj-encuesta="objEncuesta"  :flag-reload="flagReloadTable"  ></data-table-invitaciones-encuesta>
         </div>
         </div>
      </v-card>
      <v-snackbar
        key="snackbar_dialogresponsables2"
        v-model="snackbar2"
        :bottom="true"
        :multi-line="true"
        :color="snackbarColor2"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        {{ snackbarTexto2 }}
        <v-btn 
            dark 
            text 
            @click="snackbar2 = false">
            Cerrar
        </v-btn>
      </v-snackbar>
    </v-dialog>
    <v-dialog v-model="dialogConfirmar" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Está seguro?</v-card-title>
        <v-card-text>Se perderán los cambios que no hayan sido guardados. ¿Desea continuar?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="dialogConfirmar = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="dialogConfirmar = false; dialog = false;">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      key="snackbar_dialogresponsables"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { getGruposParticipanteEncuesta } from "@/api";
export default {
  name: "DialogParticipantes",
  components: {
    SelectEstados: () =>import("../comunes/SelectEstado"),
     SelectCiudades: () =>import("../comunes/SelectCiudad"),
    FormParticipantesEncuestas: () =>import("../bandejaEncuestas/FormParticipantesEncuestas"),
    FormEncuestaParticipante: () =>import("../bandejaEncuestas/FormEncuestaParticipante"),
    DataTableInvitacionesEncuesta:()=>import("../bandejaEncuestas/DataTableInvitacionesEncuesta"),
  },
  props: {
    objEncuesta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      valido: false,
      loadingEncuesta: true,  
      error: "",
      dialog: false,
      dialogConfirmar: false,
      loading: true,
      disabledNew: false,
      flagReloadTable: 1,
      flagReloadTable2: 1,
      flag:1,
      flag2:2,
      flagInitForm: 1,
      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",
      snackbar2: false,
    snackbarTexto2: "",
      snackbarColor2: "",
    };

  },
  computed: {
  },
  watch:{
    dialog: {
      handler(newValue, oldValue) {
        if(newValue == true){
        this.flagReloadTable++;   
         this.obtenerGruposParticipanteEncuesta();  
        }
      },
    },
  },
  beforeMount () {},
  async mounted () {
  },
  methods: {
    fnAddFlagTable(){
      this.flagReloadTable++;
    },
    
  async obtenerGruposParticipanteEncuesta () {
      var self = this;
      self.loading = true;
      self.snackbarError = false;
      self.textoError = "";
      var idEncuesta=self.objEncuesta.idEncuesta;
      try {
        let response = await getGruposParticipanteEncuesta(idEncuesta);
        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.objParticipantesEncuesta = response.data.data;
              self.flagReloadTable++;
               self.valido = true;
              self.loadingEncuesta = false;
              self.loading = false;
            }
          } else {
            self.snackbarTexto = "DataTableParticipantes: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableParticipantes: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
      }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableParticipantes: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
  },  
};
</script>